const CourseOrderList = () => import('@/vuepage/orders-manage/CourseOrderList');
const CourseOrderDetail = () => import('@/vuepage/orders-manage/components/CourseOrderDetail');
const TrainingOrderList = () => import('@/vuepage/orders-manage/TrainingOrderList');
const TrainingOrderDetail = () => import('@/vuepage/orders-manage/components/TrainingOrderDetail');
const MemberOrderList = () => import('@/vuepage/orders-manage/MemberOrderList');
const MemberOrderDetail = () => import('@/vuepage/orders-manage/components/MemberOrderDetail');

export default [{
		path: '/course-order-list',
		component: CourseOrderList,
		meta: [{
				name: '订单管理'
			},
			{
				name: '课程订单',
				activeRoute: '/course-order-list'
			}
		]
	},
	{
		path: '/course-order-detail',
		component: CourseOrderDetail,
		meta: [{
				name: '订单管理'
			},
			{
				name: '课程订单',
				activeRoute: '/course-order-list'
			},
			{
				name: '课程订单详情',
				activeRoute: '/course-order-detail'
			}
		]
	},
	{
		path: '/training-order-list',
		component: TrainingOrderList,
		meta: [{
				name: '订单管理'
			},
			{
				name: '培训订单',
				activeRoute: '/training-order-list'
			}
		]
	},
	{
		path: '/training-order-detail',
		component: TrainingOrderDetail,
		meta: [{
				name: '订单管理'
			},
			{
				name: '培训订单',
				activeRoute: '/training-order-list'
			},
			{
				name: '培训订单详情',
				activeRoute: '/training-order-detail'
			}
		]
	},
	{
		path: '/member-order-list',
		component: MemberOrderList,
		meta: [{
				name: '订单管理'
			},
			{
				name: '会员订单',
				activeRoute: '/member-order-list'
			}
		]
	},
	{
		path: '/member-order-detail',
		component: MemberOrderDetail,
		meta: [{
				name: '订单管理'
			},
			{
				name: '会员订单',
				activeRoute: '/member-order-list'
			},
			{
				name: '会员订单详情',
				activeRoute: '/member-order-detail'
			}
		]
	},

];